import { render } from "./NcrmPrivacyNoticeDrawer.vue?vue&type=template&id=62802158&scoped=true"
import script from "./NcrmPrivacyNoticeDrawer.vue?vue&type=script&lang=js"
export * from "./NcrmPrivacyNoticeDrawer.vue?vue&type=script&lang=js"

import "./NcrmPrivacyNoticeDrawer.vue?vue&type=style&index=0&id=62802158&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62802158"]])

export default __exports__